import { checkForApacCountry } from '@/config/constants/countries.js'

import {
  ABOUT_PATH,
  BACKSTAGE_DOMAIN,
  CONTACT_US_PATH,
  CULTURE_SUBDOMAIN,
  CUSTOMER_SERVICE_SUBDOMAIN,
  DEALERS_PATH,
  EVENTS_PATH,
  FAQ_PATH,
  FRIENDBUY_PATH,
  INVESTORS_SUBDOMAIN,
  PDP_GIFT_CARDS_PATH,
  ORDER_STATUS_PATH,
  PRESS_SUBDOMAIN,
  RETURNS_EXCHANGE_PATH,
  RETURNS_NEW_PATH,
  SHIPPING_RETURNS_PATH,
  SIZE_GUIDE_PATH,
  SUSTAINABILITY_PATH,
  TECHNOLOGY_PATH,
  TRANSPARENCY_PATH,
  WARRANTY_CLAIMS_NEW_PATH,
  WWW_SUBDOMAIN,
} from '@/config/constants'

export default [
  {
    id: 'help',
    key: 'help',
    baseUrl: CUSTOMER_SERVICE_SUBDOMAIN,
    path: '',
    title: true,
    links: [
      {
        id: 'contact',
        key: 'contact_us',
        baseUrl: CUSTOMER_SERVICE_SUBDOMAIN,
        path: CONTACT_US_PATH,
      },
      {
        id: 'faq',
        key: 'faqs',
        baseUrl: CUSTOMER_SERVICE_SUBDOMAIN,
        path: FAQ_PATH,
      },
      {
        id: 'order-tracking',
        key: 'order_status',
        baseUrl: CUSTOMER_SERVICE_SUBDOMAIN,
        path: ORDER_STATUS_PATH,
      },
      {
        id: 'shipping',
        key: 'shipping_and_returns',
        baseUrl: CUSTOMER_SERVICE_SUBDOMAIN,
        path: SHIPPING_RETURNS_PATH,
      },
      {
        id: 'size-guide',
        key: 'size_guide',
        baseUrl: CUSTOMER_SERVICE_SUBDOMAIN,
        path: SIZE_GUIDE_PATH,
      },
      {
        id: 'where-to-buy',
        key: 'where_to_buy',
        baseUrl: CUSTOMER_SERVICE_SUBDOMAIN,
        path: DEALERS_PATH,
      },
      {
        id: 'gift-cards',
        key: 'gift_cards',
        baseUrl: WWW_SUBDOMAIN,
        path: PDP_GIFT_CARDS_PATH,
        checkVisibility: () => checkForApacCountry() === false,
      },
      {
        id: 'refer-a-friend',
        key: 'refer_friend',
        baseUrl: WWW_SUBDOMAIN,
        path: FRIENDBUY_PATH,
      },
      {
        id: 'returns',
        key: 'returns_and_exchanges',
        baseUrl: CUSTOMER_SERVICE_SUBDOMAIN,
        path: RETURNS_EXCHANGE_PATH,
        subtitle: true,
      },
      {
        id: 'returns-form',
        key: 'return_exchange_form',
        baseUrl: CUSTOMER_SERVICE_SUBDOMAIN,
        path: RETURNS_NEW_PATH,
      },
      {
        id: 'warranty-form',
        key: 'warranty_claim_form',
        baseUrl: CUSTOMER_SERVICE_SUBDOMAIN,
        path: WARRANTY_CLAIMS_NEW_PATH,
      },
    ],
  },

  {
    id: 'about',
    key: 'about',
    baseUrl: WWW_SUBDOMAIN,
    path: ABOUT_PATH,
    title: true,
    links: [
      {
        id: 'story',
        key: 'story',
        baseUrl: WWW_SUBDOMAIN,
        path: ABOUT_PATH,
      },
      {
        id: 'careers',
        key: 'careers',
        baseUrl: CULTURE_SUBDOMAIN,
        path: '',
        hasLocale: false,
      },
      {
        id: 'events',
        key: 'events',
        baseUrl: WWW_SUBDOMAIN,
        path: EVENTS_PATH,
      },
      {
        id: 'investors',
        key: 'investors',
        baseUrl: INVESTORS_SUBDOMAIN,
        path: '',
        hasLocale: false,
      },
      {
        id: 'press',
        key: 'press',
        baseUrl: PRESS_SUBDOMAIN,
        path: '/choose-your-language',
        hasLocale: false,
      },
      {
        id: 'sustainability',
        key: 'sustainability',
        baseUrl: WWW_SUBDOMAIN,
        path: SUSTAINABILITY_PATH,
      },
      {
        id: 'transparency',
        key: 'transparency',
        baseUrl: WWW_SUBDOMAIN,
        path: TRANSPARENCY_PATH,
      },
      {
        id: 'technology',
        key: 'technology',
        baseUrl: WWW_SUBDOMAIN,
        path: TECHNOLOGY_PATH,
      },
      {
        id: 'backstage',
        key: 'on_backstage',
        baseUrl: BACKSTAGE_DOMAIN,
        path: '',
        hasLocale: false,
      },
    ],
  },
]
